const { countries } = require('countries-list')
const slugify = require('slugify');

const getSlugifiedCountryNameByCode = (code) => {
    return slugify(countries[code].name, { lower: true });
}

window.getSlugifiedCountryNameByCode = getSlugifiedCountryNameByCode;
